import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import HomePage from "@/pages/HomePage";
import LandingPage from "@/pages/LandingPage";
import ManagerDashboard from "@/pages/ManagerDashboard";
import ClaimsAnalytics from "./pages/ClaimsAnalytics";
import BookingSystem from "@/pages/BookingSystem";
import JobsList from "@/pages/JobsList";
import InstallerManagement from "@/pages/InstallerManagement";
import AssignmentDashboard from "@/pages/AssignmentDashboard";
import InstallerView from "@/pages/InstallerView";
import AdsDashboard from "@/pages/AdsDashboard";
import CalendarPage from "@/pages/CalendarPage";
import { Toaster } from "@/components/ui/sonner";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/h2g" element={<HomePage />} />
          <Route path="/warranty" element={<LandingPage />} />
          <Route path="/dashboard" element={<ManagerDashboard />} />
          <Route path="/analytics" element={<ClaimsAnalytics />} />
          <Route path="/booking" element={<BookingSystem />} />
          <Route path="/jobs" element={<JobsList />} />
          <Route path="/installers" element={<InstallerManagement />} />
          <Route path="/assignments" element={<AssignmentDashboard />} />
          <Route path="/installer/:linkSlug" element={<InstallerView />} />
          <Route path="/ads" element={<AdsDashboard />} />
          <Route path="/calendar" element={<CalendarPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;